import { Directive, ElementRef, inject, OnInit } from '@angular/core';

import { ApWindowService } from '@ap/cdk';
import { ApContentItem, ApContentService } from '@ap/content';
import { ApPegaResource } from '@ap/pega';

import content from './product-openen.content.json';
import { productIDs } from './product-openen.model';

@Directive()
export class ProductOpenenDirective implements OnInit {
    public content: any;

    public caseTypeId = 'Vb-PcAsKbv-Work-Orientate';
    public caseID: string;
    public assignmentID: string;
    public actionID: string;
    public useState = true;
    public initWithSubmit = false;
    public titles: Map<string, string>;
    public title: string;
    public requestType: string;
    public requestSubType: string;

    private readonly parameterObjects = {};
    private productId: string;
    private pairingCode: string;
    private verificationMethod: string;

    protected readonly element: ElementRef = inject(ElementRef);
    protected readonly contentService: ApContentService = inject(ApContentService);
    protected readonly pegaResource: ApPegaResource = inject(ApPegaResource);
    protected readonly windowService: ApWindowService = inject(ApWindowService);

    public ngOnInit(): void {
        this.contentService.addContentItems(content as ApContentItem);
        this.getParameters();

        this.productId =
            this.getXCParameter('productId') ||
            this.getParameter('productId') ||
            this.getParameter('productid') ||
            this.getParameter('productID');
        this.requestType = this.getXCParameter('requestType') || this.getParameter('requestType');
        this.requestSubType = this.getXCParameter('requestSubType') || this.getParameter('requestSubType');
        this.caseID = this.getParameter('caseID');
        this.assignmentID = this.getParameter('assignmentID');
        this.actionID = this.getParameter('actionID');
        this.pairingCode = this.getParameter('pairingCode');
        this.verificationMethod = this.getXCParameter('verificationMethod') || this.getParameter('verificationMethod');

        this.title = this.getTitle();

        this.content = {
            /* eslint-disable @typescript-eslint/naming-convention */
            ProductID: this.productId,
            RequestType: this.requestType.replace(/(^\w)/g, (letter) => letter.toUpperCase())
            /* eslint-enable @typescript-eslint/naming-convention */
        };

        if (this.requestSubType) {
            this.content.RequestSubType = this.requestSubType.replace(/(^\w)/g, (letter) => letter.toUpperCase());
        }

        if (this.pairingCode) {
            this.content.ActionType = 'PairingCode';
            this.content.ActionValue = this.pairingCode;
        }

        if (this.verificationMethod) {
            this.content.VerificationMethod = this.verificationMethod;
        }
    }

    protected getTitle(): string {
        if (this.titles === undefined) {
            this.titles = new Map(productIDs.map((id) => [id, this.contentService.get(`productName.${id}`)]));
        }
        const title: string = this.titles.get(this.productId) || this.contentService.get('productName');

        if (this.requestType.toLowerCase() === 'joint') {
            return `${title} samen openen`;
        }
        return `${title} openen`;
    }

    private getParameters(): void {
        const urlParameters: string = this.getUrlParameters();
        if (urlParameters) {
            const parameters: string[] = urlParameters.split('&');
            parameters.forEach((parameter) => {
                const item = parameter.split('=');
                this.parameterObjects[item[0]] = item[1];
            });
        }
    }

    private getUrlParameters(): string {
        const url = new URL(this.windowService.location_href() as string);
        let urlParameters: string = url.hash.split('?')[1];
        if (urlParameters === null || urlParameters === undefined) {
            urlParameters = url.search.split('?')[1];
        }
        return urlParameters;
    }

    private getXCParameter(key: string): string {
        return this.element.nativeElement.getAttribute(key);
    }

    private getParameter(key: string): string {
        return this.parameterObjects[key] ? this.parameterObjects[key] : '';
    }
}
